export var CommLink;
(function (CommLink) {
    CommLink["AEHF"] = "AEHF";
    CommLink["GALILEO"] = "Galileo";
    CommLink["IRIDIUM"] = "Iridium";
    CommLink["STARLINK"] = "Starlink";
    CommLink["WGS"] = "WGS";
})(CommLink || (CommLink = {}));
